import type DataStoreOptions from './DataStoreOptions';
import useDataStore from './useDataStore';

export type { DataStoreOptions };

export default useDataStore;
